import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { HandleTeamReport } from 'domain/usecases';

export class RemoteHandleTeamReport implements HandleTeamReport {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<HandleTeamReport.Result>,
  ) {}

  async execute(
    params: HandleTeamReport.Params,
  ): Promise<HandleTeamReport.Result> {
    const { type, ...rest } = params;

    const requestUrl = generateUrl(`${this.url}/export/${type}`, { ...rest });

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
